import {MoneyPrice, PriceSource} from '../../../core/money';

export enum QuotePaymentType {
  DefaultDeposit = 'DefaultDeposit',
}

export interface QuoteRoom {
  roomId: string;
  occupancies: QuoteOccupancy[];
  extras: any[];
}

export interface QuoteOccupancy {
  occupancyId: number;
  quantity: number;
  price: PriceSource;
}

export interface QuoteExtra {
  extraId: number;
  quantity: number;
  price: PriceSource;
}

export interface QuoteInsurance {
  depositText: string;
  insuredAmount: PriceSource;
  ipidUrl: string;
  logoUrl: string;
  name: string;
  price: PriceSource;
  termsUrl: string;
}

export interface QuoteTaxes {
  includedTaxes: QuoteTax;
  excludedTaxes: QuoteTax;
  onSiteTaxes: QuoteTax;
}

export interface QuoteTax {
  computations: QuoteComputation[];
  totalAmount: MoneyPrice;
}

export interface QuoteComputation {
  isIncluded: boolean;
  name: string;
  paymentTime: string;
  price: PriceSource;
  summary: string;
  type: string;
}

export interface QuotePaymentModes {
  name: string;
  type: string;
  title: string;
  description: string;
  depositAmount: PriceSource;
  cancellationInsuranceAllowed: boolean;
  supportedCardTypes: string[];
  supportedPaymentMethods: string[];
}

export interface QuoteSellingConditions {
  totalAmount: PriceSource;
  guaranteeAmount: PriceSource;
  balanceAmount: PriceSource;
  bookingFeesAmount: PriceSource;
  balanceText: string;
}

export interface QuoteMarketing {
  isOptinHotelAvailable: boolean;
  isOptinPartnersAvailable: boolean;
}

export interface QuoteCustomFields {
  isVisible: boolean;
  isMandatory: boolean;
  translationTag: string;
  name: string;
}

export interface QuoteCreateBody {
  customerDetails: QuoteCreateCustomerDetail;
  paymentType?: QuotePaymentType;
  subscribeInsurance?: boolean;
  guestDetails?: QuoteCreateGuestDetail[];
  specialRequest?: string;
}

export interface QuoteCreateGuestDetail {
  title?: string;
  type?: string;
  firstName?: string;
  lastName?: string;
  roomId?: number;
  occupancyId?: number;
  itemNumber?: number;
}

export interface QuoteCreateCustomerDetail {
  firstName: string | undefined;
  lastName: string | undefined;
  countryCode: string | undefined;
  emailAddress: string | undefined;
  title?: string;
  arrivalTime?: string;
  phoneNumber?: string;
  phoneCountryCode?: string;
  addressLines?: string[];
  cityName?: string;
  postalCode?: number;
  marketingConsent?: {
    optinHotel: boolean,
    optinPartners: boolean,
    optinHotelAccepted: boolean,
    optinPartnersAccepted: boolean,
  };
}

export interface QuoteCreate {
  redirectionUrl: string;
}
